import { Pipe, type PipeTransform } from '@angular/core';

@Pipe({
    name: 'HtmlEncode',
    standalone: true,
})
export class HtmlEncodePipe implements PipeTransform {
    transform(value: string): string {
        return this.escape(value);
    }

    private escape(string: string) {
        return string.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&#39;');
    }
}
